import { Component, forwardRef, Renderer2, ViewChild, Input, Output, EventEmitter, OnChanges } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { PqrTypificationService } from '../../../service/pqr-typification/pqr-typification.service';
import { sortObjbyName } from '../../../../../theme/functions/sortObjbyName.function';

export const EPANDED_TEXTAREA_VALUE_ACCESSOR: any = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => SelectPqrTypificationComponent),
  multi: true,
};

@Component({
  selector: 'app-select-pqr-typification',
  templateUrl: './select-pqr-typification.component.html',
  styleUrls: ['./select-pqr-typification.component.scss'],
  providers: [EPANDED_TEXTAREA_VALUE_ACCESSOR],
})
export class SelectPqrTypificationComponent implements ControlValueAccessor, OnChanges {
    @Input() pqrTypificationId: number;
    @Input() departmentId: number;
    @Output() onMyChange = new EventEmitter();
    @ViewChild('input') textarea;
    @Input() disabled: boolean;

    public pqrTypificationsOptions: any[];

    public onChange;
    public onTouched;
    public totalRecords: number;
    public page: number;
    public per_page: number;
    public sort: string;
    public query: string;
    public filters: {key: string, value: string}[];

    constructor(
        private renderer: Renderer2,
        public pqrTypifiactionService: PqrTypificationService
    ) {
        this.page = 1;
        this.per_page = 1000;
        // this.query = undefined;
        // this.filters = [];
        // this.filters.push({key: 'activated-lk', value: '1'});
        // if (this.departmentId) {
        //     this.filters.push({key: 'department_id-in', value: String(this.departmentId)});
        // }
        // this.getPqrTypifications(this.query, this.filters);
    }

    ngOnChanges() {
        this.query = undefined;
        this.filters = [];
        this.filters.push({key: 'activated-lk', value: '1'});
        if (this.departmentId) {
            this.filters.push({key: 'department_id-in', value: String(this.departmentId)});
        }
        this.getPqrTypifications(this.query, this.filters);
    }

    writeValue(value: any ) {
        const div = this.textarea.nativeElement;
        // this.renderer.setProperty(div, 'textContent', value);
    }

    registerOnChange(fn: any ) {
        this.onChange = fn;
    }

    registerOnTouched(fn: any ) {
        this.onTouched = fn;
    }

    setDisabledState(isDisabled: boolean ) {
        const div = this.textarea.nativeElement;
        const action = isDisabled ? 'addClass' : 'removeClass';
        this.renderer[action](div, 'disabled');
    }

    public change($event) {
        this.onMyChange.emit($event);
        this.onChange($event.target.value);
        this.onTouched($event.target.value);
    }

    getPqrTypifications(query?: string, filters?: any[]) {
        this.pqrTypifiactionService.getPqrTypification(this.page, this.per_page, this.sort, this.query, this.filters).toPromise().then(
            response => {
                // var pqrTypifiactions = response.json().data;
                this.pqrTypificationsOptions = [];
                this.pqrTypificationsOptions = sortObjbyName(response.json().data,'asc');
                if (response.json().meta.total > response.json().meta.total_filtered) {
                    this.totalRecords = response.json().meta.total_filtered;
                } else {
                    this.totalRecords = response.json().meta.total;
                }

                this.pqrTypificationsOptions.unshift({id: undefined, name: 'choose'});
                const selectedItemIndex = this.pqrTypificationsOptions.findIndex(item => item.id == this.pqrTypificationId);

                if (selectedItemIndex !== -1) {
                    const selectedItem = this.pqrTypificationsOptions[selectedItemIndex];
                    selectedItem.selected = true;
                    this.pqrTypificationsOptions[selectedItemIndex] = selectedItem;
                }

                // pqrTypifiactions.forEach(element => {
                //     if (this.pqrTypificationId == element.id) {
                //         this.pqrTypificationsOptions.push({id: element.id, name: element.name, selected: true});
                //     } else {
                //         this.pqrTypificationsOptions.push({id: element.id, name: element.name, selected: false});
                //     }
                // });
            },
            error => {
                this.pqrTypificationsOptions = [];
                this.pqrTypificationsOptions.push({id: '', name: 'Error'});
            }
        );
    }
}



// WEBPACK FOOTER //
// D:/inetpub/wwwroot/kaizen-ng/src/app/modules/employee/pages/pqr-typifications/select-pqr-typification/select-pqr-typification.component.ts